import {ModuleProto} from "../../module-proto";
import {ModuleType} from "../../types";
import {SettingsMenuTopCategory} from "../../settings-module";
import {SettingsParentSection} from "../../../../app/settings/const";

// const debug = "GoogleCalendarModule"
const debug = false

export class OutlookCalendarModule extends ModuleProto {

    public accounts         : any[]
    public calendars        : any[]

    constructor() {
        super(ModuleType.OUTLOOK_CALENDAR, {});

        debug && console.log(debug, "constructor() moduleConfig={???}")

        this.name                       = "Outlook Calendar"
        this.description                = "The Outlook Calendar module offers a two-way integration that ensures your GoodDay events and tasks and Outlook stay perfectly aligned. Changes made in one automatically update in the other, offering a seamless and efficient scheduling experience that keeps your planning accurate and up-to-date."
        this.svgIcon                    = "isvg-outlook-integration"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.INTEGRATIONS
        this.typeLabel                  = "Integrations"
        this.accounts                   = []
        this.settingsUrl                = "settings/integrations/ocalendar"
        this.parentSection              = SettingsParentSection.INTEGRATIONS

        this.calendars                  = []

        this.canAccess                  = true

        this.canDisable                 = false
        this._isEnabled                 = true // because this.canDisable false

        debug && console.log(debug, "_isEnabled", this._isEnabled)
    }


    toJson() {
        debug && console.log(debug, "toJson() type=",this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }
}
